module.exports = __webpack_public_path__ + "img/hr-green-carpet-grass-04.88420f78.png";